import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const OpenEyeIcon = props => {
  return (
    <Svg
      width={20}
      height={15}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 7.5a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM10 5.25a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
        fill="#5C697B"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.323 6.146C1.904 6.75 1.75 7.223 1.75 7.5c0 .277.154.75.573 1.354.406.583 1.008 1.216 1.77 1.801C5.62 11.827 7.713 12.75 10 12.75s4.38-.923 5.907-2.095c.762-.585 1.364-1.218 1.77-1.801.419-.604.573-1.077.573-1.354 0-.277-.154-.75-.573-1.354-.406-.583-1.008-1.216-1.77-1.801C14.38 3.173 12.287 2.25 10 2.25s-4.38.923-5.907 2.095c-.762.585-1.364 1.218-1.77 1.801zm.856-2.991C4.91 1.827 7.316.75 10 .75s5.09 1.077 6.82 2.405c.867.665 1.583 1.407 2.089 2.136.492.709.841 1.486.841 2.209 0 .723-.35 1.5-.841 2.209-.506.729-1.222 1.47-2.088 2.136-1.73 1.328-4.137 2.405-6.821 2.405s-5.09-1.077-6.82-2.405c-.867-.665-1.583-1.407-2.089-2.136C.6 9 .25 8.223.25 7.5c0-.723.35-1.5.841-2.209.506-.729 1.222-1.47 2.088-2.136z"
        fill="#5C697B"
      />
    </Svg>
  );
};

export default OpenEyeIcon;
